import { useRouter } from 'next/router';
import { pathnames } from 'utils/routerHelpers';

import React from 'react';

import { Text } from '@thinkific/chalk/react-components';

import CommunityGlobalHeader from './CommunityGlobalHeader';
import DirectMessagingGlobalHeader from './DirectMessagingGlobalHeader';
import * as css from './GlobalHeader.css';

interface BaseGlobalHeaderProps {
  title?: string;
  leftContent?: React.ReactNode;
  rightContent?: React.ReactNode;
}

export const BaseGlobalHeader = ({ title, leftContent, rightContent }: BaseGlobalHeaderProps) => {
  return (
    <header className={css.container} data-qa="top-bar">
      <div className={css.leftContainer}>
        <Text as="h1" className={css.adminTitle} variant="display.sm">
          {title}
        </Text>
        {leftContent}
      </div>
      <div className={css.rightContainer}>{rightContent}</div>
    </header>
  );
};

export const GlobalHeader = ({ title }: { title?: string }) => {
  const router = useRouter();

  const PATHNAME_TO_HEADER = {
    [pathnames.directMessaging.index]: DirectMessagingGlobalHeader,
    [pathnames.directMessaging.conversation]: DirectMessagingGlobalHeader,
  };

  const Element = PATHNAME_TO_HEADER[router.pathname] || CommunityGlobalHeader;

  return <Element title={title} />;
};

export default GlobalHeader;
